import React, { FC } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

import { AccountMobileAppBar } from "./AccountMobileAppBar";
import { Footer } from "@websential/cosmic-v20";
import Grid from "@mui/material/Grid";

export interface IAccountLayout {
	contents?: React.ReactNode;
	contentColumns?: number
}

export const AccountLayout: FC<IAccountLayout> = ({
	contents,
	contentColumns = 8
}: IAccountLayout) => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen || isMediumScreen01;

	const testId = "account-layout";
	const onSimplePayClickedHandler = () => {
		// window.open("https://www.simplepay.com/", "_self");
	};
	return (
		<>
			{mobileTabOrSmallLaptopScreen &&
				<AccountMobileAppBar
					toolbarMenuContent={<>Menu</>}
					appBarHeader={
						<img
							src={`https://www.simplepay.ca/canada_payroll/index/img/simplepay_logo.png`}
							alt="loading"
							// width="100%"
							onClick={onSimplePayClickedHandler}
							style={{ cursor: "pointer", width: "fit-content" }}
						/>
					}
				/>}
			<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					alignItems: "center",
					minHeight: mobileTabOrSmallLaptopScreen
						? "calc(100vh - 64px)" // subtract the mobile AppBar height
						: "100vh",
					paddingTop: mobileTabOrSmallLaptopScreen ? "32px" : 0,
					marginTop: mobileTabOrSmallLaptopScreen ? "64px" : 0,
				}}
			>
				{!mobileTabOrSmallLaptopScreen && <Grid
					// container
					// direction="column"
					// alignItems="center"
					size={{ xs: 0, sm: 0, md: 4, lg: 4, xl: 4 }}
					sx={{ backgroundColor: theme.palette.primary.main, height: "-webkit-fill-available" }}
				>
					<Grid
						sx={{
							display: "flex",
							alignItems: "center",
							height: "40vh",
							justifyContent: "center"
						}}
						data-testid={testId + "-logo"}
					>
						<img
							src={`https://www.simplepay.ca/canada_payroll/index/img/simplepay_logo.png`}
							alt="loading"
							width="100%"
							onClick={onSimplePayClickedHandler}
							style={{ cursor: "pointer", width: "fit-content" }}
						/>
					</Grid>
					<Grid
						sx={{
							height: "60vh",
							display: "flex",
							alignItems: "flex-end",
						}}
						data-testid={testId + "-bottomImage"}
					>
						{/* <img
						src={`${process.env.PUBLIC_URL}/images/left-bottom-img.jpg`}
						alt="loading"
						width="100%"
					/> */}
					</Grid>
				</Grid>}



				<Grid size={{ xs: 1, sm: 2, md: mobileTabOrSmallLaptopScreen ? 2 : (8 - contentColumns) / 2, lg: (8 - contentColumns) / 2, xl: (8 - contentColumns) / 2 }}></Grid>
				<Grid
					// container
					// direction="column"
					alignItems="center"
					size={{ xs: 10, sm: 8, md: mobileTabOrSmallLaptopScreen ? 8 : contentColumns, lg: contentColumns, xl: contentColumns }}
				// size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
				// sx={{ marginY: "auto" }}
				>
					{/* <Grid
					// container
					sx={{
						// height: "90vh",
						// display: "flex",
						// alignItems: "center",
					}}
					data-testid={testId + "-content"}
				> */}
					{contents}
					{/* </Grid> */}
					{/* <Grid
          item
          sx={{
            height: "10vh",
            display: "flex",
            alignItems: "flex-end",
          }}
          data-testid={testId + "-footer"}
        >
          <Footer />
        </Grid> */}
				</Grid>
				<Grid size={{ xs: 1, sm: 2, md: mobileTabOrSmallLaptopScreen ? 2 : (8 - contentColumns) / 2, lg: (8 - contentColumns) / 2, xl: (8 - contentColumns) / 2 }}></Grid>
			</Grid>
		</>
	);
};
